import React, {useContext} from 'react';
import {sideMenuContext} from "../../../router/IndexRouter";
import {Button} from "antd";

const EditComponent = ({item, url}) => {
    const {setCurrentItem} = useContext(sideMenuContext)
    const editClick = () => {
        // console.log(item)
        setCurrentItem(item);
        window.open(url + "/edit", "_self");
    }

    return (
        <Button type="link" onClick={() => editClick()}>编辑</Button>
    );
};

export default EditComponent;
